import dJSON from 'dirty-json';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.info-cards';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.insertAdjacentHTML('beforeend', /* html */ `
          <div class="info-card">
            <div class="info-card__image">
              <img src="${item.backgroundImage}" alt="${item.title}">
            </div>
            <div class="info-card__content">
              <h3 class="info-card__title">${item.title}</h3>
              ${item.text ? `<div class="info-card__text">${item.text}</div>` : ''}
              ${item.buttonText && item.buttonLink ? `<a class="info-card__button ${item.buttonColor}" href="${item.buttonLink}">${item.buttonText}</a>` : ''}
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
